export type SingleSearchBillingAccount = {
	accountId: string;
	billingId: string;
	billingAccountName: string;
	lines: string;
	billingAccountType: string;
	accType: string;
};

const model: types.models.InputModel = {
	accountId: 'accountId',
	billingId: 'billingId',
	billingAccountName: 'billingAccountName',
	lines: 'lines',
	billingAccountType: 'billingAccountType',
	accType: 'accType',
};

export default model;
